import { RegisterCard } from "../../components/RegisterCard";
import { useState } from "react";
import { CircleLoader } from "../../components/CircleLoader";
import { Package, Plus, ClipboardList } from "lucide-react";

export const CAsupplies = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const [items, setItems] = useState<string[]>([]);
  const supplyOptions = [
    "Diapers",
    "Wipes",
    "Clothes",
    "Water Bottle",
    "Soap",
    "Medication",
  ];

  const toggleItem = (supply: string) => {
    setItems((prev) =>
      prev.includes(supply)
        ? prev.filter((i) => i !== supply)
        : [...prev, supply],
    );
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    formData.items_needed = items;
    onFormSubmit(e);
  };

  return (
    <div className="w-full max-w-5xl mx-auto p-4">
      <RegisterCard
        title="Supplies Needed"
        details="Notify parents about low inventory."
      />

      <form
        onSubmit={handleSubmit}
        className="mt-6 bg-white rounded-[3rem] border border-slate-100 shadow-2xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 lg:p-12 space-y-10 order-2 lg:order-1">
          <div className="space-y-4">
            <label className="flex items-center gap-2 text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
              <Package size={14} /> Select Items Needed
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {supplyOptions.map((opt) => (
                <button
                  key={opt}
                  type="button"
                  onClick={() => toggleItem(opt)}
                  className={`py-4 rounded-2xl border-2 font-bold text-xs transition-all
                    ${
                      items.includes(opt)
                        ? "bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-200"
                        : "bg-slate-50 border-transparent text-slate-500 hover:bg-slate-100"
                    }`}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <label className="flex items-center gap-2 text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
                <ClipboardList size={14} /> Specific Instructions
              </label>
              <textarea
                value={formData["description"]}
                onChange={(e) => onFormChange("description", e.target.value)}
                className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-3xl min-h-[120px] outline-none focus:bg-white focus:border-blue-500 transition-all"
                placeholder="E.g. Size 4 diapers please..."
              />
            </div>
            <div className="space-y-4">
              <label className="text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
                Other Items
              </label>
              <textarea
                value={formData["others"]}
                onChange={(e) => onFormChange("others", e.target.value)}
                className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-3xl min-h-[120px] outline-none focus:bg-white focus:border-blue-500 transition-all"
                placeholder="Anything else not listed above..."
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 text-white rounded-3xl font-black uppercase tracking-widest hover:bg-black transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <Plus /> Send Supply Request
              </>
            )}
          </button>
        </div>

        <div className="hidden lg:flex lg:w-80 bg-slate-50 items-center justify-center p-10 order-1 lg:order-2 border-l border-slate-100">
          <img
            src="/img/stationery.svg"
            className="w-48 h-48 drop-shadow-2xl animate-float"
            alt="supplies"
          />
        </div>
      </form>
    </div>
  );
};
